import { getToken } from "./authToken";

const API_URL = import.meta.env.VITE_API_URL || "";

export async function uploadEmployeeFile(
  file: File,
  employeeId: string,
  fieldName: string
): Promise<string> {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("employee_id", employeeId);
  formData.append("field_name", fieldName);

  const token = getToken();
  if (!token) {
    throw new Error("尚未登入，請重新登入");
  }

  const response = await fetch(`${API_URL}/api/functions/upload-employee-file`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });

  const responseText = await response.text();
  let result: { success?: boolean; url?: string; error?: string } = {};

  try {
    result = JSON.parse(responseText);
  } catch {
    throw new Error(responseText || "上傳失敗，請稍後再試");
  }

  if (!response.ok || !result.success) {
    throw new Error(result.error || "上傳失敗，請稍後再試");
  }

  if (!result.url) {
    throw new Error("上傳成功但未回傳圖片連結");
  }

  return result.url;
}
